/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CondizioneAltroCasoDTO { 
    dimensione?: CondizioneAltroCasoDTODimensioneEnum;
    operatore?: CondizioneAltroCasoDTOOperatoreEnum;
    da?: number;
    a?: number;
    valori?: Array<string>;
    valore_booleano?: boolean;
}
export enum CondizioneAltroCasoDTODimensioneEnum {
    VALORE_ISEE = 'VALORE_ISEE',
    POSSESSO_ISEE = 'POSSESSO_ISEE',
    RESIDENZA = 'RESIDENZA',
    ORDINAMENTO = 'ORDINAMENTO',
    ORDINE_BENEFICIARIO = 'ORDINE_BENEFICIARIO',
    NUMERO_BENEFICIARI = 'NUMERO_BENEFICIARI'
};
export enum CondizioneAltroCasoDTOOperatoreEnum {
    EQ = 'EQ',
    LTE = 'LTE',
    RANGE = 'RANGE',
    IN = 'IN'
};



